import * as React from 'react'

import { makeSplit } from 'components/MCTextEditor/dataFormat/parse/utils/splitByRegExps'

import cm from './Variable.module.css'

const INVISIBLE = ['{', '}']
const split = makeSplit(INVISIBLE)

const VariableLabel = ({ children }: { text?: string; children?: React.ReactNode }) => {
  if (typeof children !== 'string') {
    return <>{children}</>
  }
  return (
    <>
      {split(children).map((str, i) => (
        <span key={i} className={INVISIBLE.includes(str) ? cm.spacer : ''}>
          {str}
        </span>
      ))}
    </>
  )
}

export default VariableLabel
